import { render, staticRenderFns } from "./stock_parts.vue?vue&type=template&id=fabd780a"
import script from "./stock_parts.vue?vue&type=script&lang=js"
export * from "./stock_parts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports